export default class Gain {

    context;
    destination;
    stream;
    started = false;
    gainFilter;
    source;
    volume = 1;

    constructor(context, track) {
        this.context = context;
        this.destination = this.context.createMediaStreamDestination(); //destination;
        if(track){
            this.stream = new MediaStream([track]);       
            this.start();
        }
    }

    setInputTrack(track) {
        this.stop();
        this.stream = new MediaStream([track]);
        this.start();
    }

    start() {
        this.started = true;
        this.source = this.context.createMediaStreamSource(this.stream);
        this.gainFilter = this.context.createGain();
        this.source.connect(this.gainFilter);
        this.gainFilter.connect(this.destination);
        if(this.volume !== -1)
            this.setVolume(this.volume);
    }

    getOutputTrack() {
        return this.destination.stream.getAudioTracks()[0];
    }

    setVolume(value) {
        this.volume = value;
        this.gainFilter.gain.setValueAtTime(this.volume, this.context.currentTime);
    }

    getVolume(){
        return this.volume;
    }
    
    stop() {
        if (this.started) {
            this.source.disconnect();
            this.gainFilter.disconnect();
            this.source = null;
            this.gainFilter = null;
        }
        this.started = false;
    }

}